export const sampleFilterList = [
  {
    name: "Active Alerts",
    filterBy: "all",
    // href: "",
    // uniqueClass: ""
  },
  {
    name: "Action Needed",
    filterBy: "Action Needed",
    // NOTE: optional parameters
    // href: "",
    // uniqueClass: ""
  },
  {
    name: "In Progress",
    filterBy: "In Progress",
    // NOTE: optional parameters
    // href: "",
    // uniqueClass: ""
  },
  {
    name: "Dismissed",
    filterBy: "Dismissed",
    // NOTE: optional parameters
    // href: "",
    // uniqueClass: ""
  },
];





// WEBPACK FOOTER //
// ./src/pages/notificationAlerts/stores/sampleFilterData.js